// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCL0ewjLvTR7mA3vs34jXCpw6OhWWSQNEc",
    authDomain: "lamynaalstechnologies.firebaseapp.com",
    projectId: "lamynaalstechnologies",
    storageBucket: "lamynaalstechnologies.firebasestorage.app",
    messagingSenderId: "548516325890",
    appId: "1:548516325890:web:d87bee71875fed0945551b",
    measurementId: "G-HTMGDH0R88"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging = null;

try {
    // Check if browser supports notifications
    if ('Notification' in window && 'serviceWorker' in navigator) {
        messaging = getMessaging(app);
    } else {
        console.warn('This browser does not support notifications');
    }
} catch (error) {
    console.error('Error initializing Firebase Messaging:', error);
}

/**
 * Request notification permission and get FCM token
 * @returns {Promise<string|null>} FCM token or null if permission denied
 */
export const requestNotificationPermission = async () => {
    try {
        console.log('🔔 [requestNotificationPermission] Starting permission request...');

        if (!messaging) {
            console.warn('⚠️  [requestNotificationPermission] Firebase Messaging not initialized');
            return null;
        }

        console.log('🔔 [requestNotificationPermission] Current permission:', Notification.permission);

        // Request permission
        const permission = await Notification.requestPermission();
        console.log('🔔 [requestNotificationPermission] Permission result:', permission);

        if (permission === 'granted') {
            console.log('✅ [requestNotificationPermission] Notification permission granted');

            // Get FCM token
            console.log('🔑 [requestNotificationPermission] Requesting FCM token from Firebase...');
            const token = await getToken(messaging, {
                vapidKey: 'BKjkWvfxh3APnoQcJeOcKIeQSs2DdCqO1TQEMcDGIeHeuQYYUVo5ibFN4H8-eUjdqMs7RaFZq5G1H_YvCRA_W4U'
            });

            if (token) {
                console.log('✅ [requestNotificationPermission] FCM Token received:', token);
                return token;
            } else {
                console.warn('⚠️  [requestNotificationPermission] No registration token available');
                return null;
            }
        } else {
            console.warn('⚠️  [requestNotificationPermission] Notification permission denied or dismissed');
            return null;
        }
    } catch (error) {
        console.error('❌ [requestNotificationPermission] Error getting notification permission:', error);
        console.error('❌ [requestNotificationPermission] Error details:', error.message);
        return null;
    }
};

/**
 * Listen for foreground messages
 * @param {Function} callback - Function to call when message is received
 */
export const onMessageListener = (callback) => {
    if (!messaging) {
        console.warn('Firebase Messaging not initialized');
        return () => { };
    }

    return onMessage(messaging, (payload) => {
        console.log('📬 Foreground message received:', payload);
        callback(payload);
    });
};

export { messaging };
export default app;
